import Prismic from "prismic-javascript";

import {
  prismicPages,
  press as pressRoute,
  faqs as faqsRoute,
  contactUs as contactUsRoute,
  getAQuote as getAQuoteRoute,
  bookACall as bookACallRoute,
  prismicStaticPages,
  caseStudies as caseStudiesRoute,
  caseStudyPages as caseStudyPagesRoute,
  stadiumBookACall as stadiumBookACallRoute,
} from "@stadium/constants";

// -- Prismic API endpoint
// Determines which repository to query and fetch data from
export const apiEndpoint = "https://snackmagic.cdn.prismic.io/api/v2";

// -- Access Token if the repository is not public
// Generate a token in your dashboard and configure it here if your repository is private
const accessToken = "";

// This is whitelisted for env configuration from only REACT APPS. Will not be required for next apps.
export const REACT_APP_TYPE = process.env.PROJECT_APP_TYPE;

export const REACT_PROJECT_TYPE = "react";

// Client method to query documents from the Prismic repo
export const client = Prismic.client(apiEndpoint, { accessToken });

export const prismicUids = {
  orderConfirmation: {
    verified: {
      pcb: "organizer-pcb",
      normal: "organizer-normal",
      goodie_bag: "us-self-goodie-bag",
    },
    anonymous: {
      pcb: "anonymous-confirmation-pcb",
      non_pcb: "anonymous-confirmation-non-pcb",
    },
  },
};

export const prismicDocTypes = {
  useCasePages: "use_case_pages",
  staticPages: "static_pages",
  featuredMenuBar: "featured_menu_bar",
  footer: "program_footer_links",
  smFooter: "snackmagic_footer_links",
  press: "press",
  caseStudiesListing: "case_studies_listing",
  caseStudyPages: "case_study_page",
  faqs: "faqs",
  orderConfirmation: "order_confirmation_page",
  headerLinks: "program_header_links",
  contactUs: "contact-us",
  productShowAboutSection: "product_show_about_section",
  headerBanner: "program_header_banner",
  smHeaderBanner: "header_banner",
  getAQuote: "standard_get_a_quote",
  smGetAQuote: "get_a_quote",
  featuredMenu: "featured_menu",
  bookACall: "standard_book_a_call",
  marketingBanner: "marketing_banner",
  smHeaderLinks: "main_navigation_bar",
  localizedFooterLinks: "localized_footer_links",
  localizedNavigationBar: "localized_navigation_bar",
  accountsSection: "accounts_section",
  searchPage: "search_page",
  menuPages: "menu_pages",
  treat_dashboard: "treat_dashboard",
  trackingPages: "tracking_pages",
  stadiumWallet: "stadium-wallet",
  swagBookACall: "swag_book_a_call",
  pricingType: "pricing_type",
  stadiumBookACall: "stadium_book_a_call",
};

export const prismicAppNames = {
  dsd: "dsd",
  snackmagic: "snackmagic",
  swagmagic: "swagmagic",
  stadium: "stadium",
  newStadium: "stadium-new-nav",
};

const {
  useCasePages,
  staticPages,
  press,
  faqs,
  caseStudiesListing,
  caseStudyPages,
  contactUs,
  getAQuote,
  bookACall,
  smGetAQuote,
  pricingType,
  stadiumBookACall,
} = prismicDocTypes;

export const linkResolver = (doc) => {
  switch (doc.type) {
    case useCasePages:
      return prismicPages.replace(":uid", doc.data.url);
    case pricingType:
      return prismicPages.replace(":uid", doc.data.url);
    case press:
      return pressRoute;
    case faqs:
      return faqsRoute;
    case contactUs:
      return contactUsRoute;
    case getAQuote:
    case smGetAQuote:
      return getAQuoteRoute;
    case bookACall:
      return bookACallRoute;
    case staticPages:
      return prismicStaticPages.replace(":uid", doc.uid);
    case caseStudiesListing:
      return caseStudiesRoute;
    case caseStudyPages:
      return caseStudyPagesRoute.replace(":uid", doc.uid);
    case stadiumBookACall:
      return stadiumBookACallRoute.replace(":uid", doc.uid);
    default:
      return "/";
  }
};

export const urlResolver = (url) =>
  (url || "").replace(`https://${process.env.NEXT_PUBLIC_PRISMIC_RESOLVER_URL}`, "");

export const defaultPrismicDocUid = "default";

export const PRISMIC_ESHOP_ORDER_TRACK_UID = "eshop-track-order";

export const SNACKMAGIC_BANNER_UID = "snackmagic-banner";

export const DSD_BANNER_UID = "dsd-banner";

export const SWAGMAGIC_BANNER_UID = "swagmagic-banner";

export const INTL_SEND_TREAT_SLICE_TYPE = "send_a_treat_button_with_image";
export const NON_INTL_SEND_TREAT_SLICE_TYPE = "multiple_icons_on_right_side";

export const FOUR_LARGE_IMAGE_ROW = "four_large_image_row";
export const HORIZONTAL_ICONS_LISTING = "horizontal_icons_listing";
export const ROW_WITH_THREE_TEXT = "row_with_3_text";
export const VERTICAL_LISTING_WITH_IMAGES = "vertical_listing_with_images";
export const NESTED_DROPDOWN = "nested_drop_down";
export const MULTIPLE_TITLE_DROPDOWN_MENU = "multiple_title_dropdown_menu";

export const FOUR_BRAND_LISTING_IN_ROW = "four_brand_listing_in_a_row";
export const BANNER_ON_RIGHT_WITH_DETAILS = "banner_on_right_with_details";
export const HORIZONTAL_LISTING_ICON_TITLE_HEADING = "horizontal_listing_with_icon_title_heading";
export const IMAGE_WITH_TEXT_LINKS = "image_with_text_links";
export const CLICKABLE_BLOCK_WITH_IMAGE_AND_TEXT = "clickable_block_with_image_and_text";
export const BOTTOM_SLICK_BAR = "bottom_sleek_bar";
export const FOUR_COLUMN_REPEATABLE_LINKS_WITH_HEADING =
  "four_column_repeatable_links_with_heading";
export const TITLE_WITH_IMAGE_ROW = "title_with_image_row";

export const MENU_WITH_COLOURED_HEADING = "menu_with_coloured_heading";
export const BANNER_WITH_BUTTONS = "banner_image_with_buttons";

export const DROPDOWN_WITH_ICON_SLICES = [
  HORIZONTAL_LISTING_ICON_TITLE_HEADING,
  IMAGE_WITH_TEXT_LINKS,
  CLICKABLE_BLOCK_WITH_IMAGE_AND_TEXT,
];
